export function useTelegram() {
  const webApp = window.Telegram.WebApp;
  const user = webApp.initDataUnsafe?.user;
  const browserLang = typeof navigator !== 'undefined' ? navigator.language : 'ru'
  const rawLang = webApp.initDataUnsafe?.user?.language_code || browserLang
  const langT = String(rawLang).toLowerCase().startsWith('ru') ? 'ru' : 'eng'
  const openExternal = (url) => {
    if (!url) return
    if (webApp?.openLink) {
      webApp.openLink(url, { try_instant_view: false })
      return
    }
    window.open(url, '_blank', 'noopener,noreferrer')
  }
  return {
    webApp,
    user,
    langT,
    openExternal,
  };
}
